// extracted by mini-css-extract-plugin
module.exports = {"modal":"NounModal_modal__4uqPE","displayNounFooter":"NounModal_displayNounFooter__2WIAf","nounImg":"NounModal_nounImg__q_OdM","nounWrapper":"NounModal_nounWrapper__yWVm-"};